import { z } from 'zod';
import { AdditionalPropertiesIdSchema } from '../enums/additional-properties-schema-id.ts';

export const AbstractAdditionalProperties = z.object({
    schemaId: AdditionalPropertiesIdSchema,
    name: z.string(),
});
